import {
    Alert24Regular,
    Bot24Regular,
    BrainCircuit24Regular,
    Calendar24Regular,
    Clock24Regular,
    DataTrending24Regular,
    Gift24Regular,
    Lightbulb24Regular,
    Money24Regular,
    People24Regular,
    Sparkle24Regular
} from "@fluentui/react-icons";
import {FC} from "react";
import {IntelligenceIcon} from "./intelligenceModels";

const ICONS: Record<IntelligenceIcon, FC> = {
    sparkle: Sparkle24Regular,
    chart: DataTrending24Regular,
    people: People24Regular,
    money: Money24Regular,
    clock: Clock24Regular,
    bot: Bot24Regular,
    bulb: Lightbulb24Regular,
    gift: Gift24Regular,
    alert: Alert24Regular,
    calendar: Calendar24Regular,
    brain: BrainCircuit24Regular
};

interface IntelligenceGlyphProps {
    icon: IntelligenceIcon;
    className?: string;
}

// Fluent icons render at 1em, so callers size them via CSS font-size.
const IntelligenceGlyph: FC<IntelligenceGlyphProps> = ({icon, className}) => {
    const Glyph = ICONS[icon];
    return (
        <span className={className} aria-hidden="true">
            <Glyph />
        </span>
    );
};

export default IntelligenceGlyph;
